var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderedListNumbers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52148 4.16699L4.52148 3.16699V6.83366M4.52148 6.83366H3.52148M4.52148 6.83366H5.18815M9.18814 9.50033H8.12564C7.63848 9.50033 7.36696 8.95758 7.62534 8.5719C7.65717 8.52439 7.70223 8.48774 7.74985 8.45606L8.94975 7.65763C8.99737 7.62594 9.04228 7.58914 9.07478 7.54208C9.37171 7.11221 9.06901 6.50033 8.5232 6.50033H7.52148M11.5215 9.83366H12.4857C13.3087 9.83366 13.4547 11.092 12.6949 11.3041C12.6581 11.3144 12.6195 11.3185 12.5813 11.3198L12.1882 11.3337L12.5813 11.3475C12.6195 11.3489 12.6581 11.353 12.6949 11.3632C13.4547 11.5753 13.3087 12.8337 12.4857 12.8337H11.5215",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderedListNumbers);
export default __webpack_public_path__ + "static/media/ordered-list-numbers.4ac750e4d799633a0e7b7cedfcf2da6d.svg";
export { ForwardRef as ReactComponent };